import { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import HeroSection from "../Components/HeroSection";
import TitleContent from "../Components/TitleContent";
import Whitepapersverticalcontainer from "../Components/Whitepapersverticalcontainer";
import BackgroundGradient from "../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../Images/BackgroundGradientSmall.png";
import Publicationsverticalcontainer from "../Components/Publicationsverticalcontainer";
import { currentSite } from "../Config/siteConfig";
export default function Publications() {
  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();
    window.addEventListener("resize", updateBackgroundImage);
    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);

  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <Header id={7} />
        <div className="w-full h-[25rem]  ">
          <HeroSection
            title1="Exploring Insights"
            title2="and Idea"
            content={`At ${
              currentSite === "site1" ? "Qulabs" : "Quantum AI Global"
            }, Browse our research publications and technical contributions that showcase our advancements in quantum and AI, highlighting our role in driving innovation and thought leadership in the field.`}
          />
        </div>
        {/* <div className="w-full bg-primary7 width  md:px-10  flex flex-col items-center justify-center ">
          <TitleContent
            title="Discover Quantum AI's White Papers"
            content="At Quantum AI, we're dedicated to harnessing the potential of quantum computing and artificial intelligence across a range of categories. From finance and healthcare to manufacturing and logistics, we're pioneering solutions that transform industries and tackle complex challenges. Explore these diverse categories to see how quantum technology can drive efficiency and innovation. Join us in exploring the possibilities and unlocking the potential of quantum technology in various fields."
          />
          <div className="mx-auto  md:px-5 2xl:px-8">
            <Whitepapersverticalcontainer />
          </div>
        </div> */}
        <div className="w-full width bg-primary7  md:px-10 pt-5 flex flex-col items-center justify-center gap-2">
          <TitleContent title="Publications" content="" />
          <div className="mx-auto  md:px-5 2xl:px-8">
            <Publicationsverticalcontainer />
          </div>
        </div>

        <Footer showpage={false} />
      </div>
    </div>
  );
}
